import styled from '@emotion/styled';
import useScrollPosition from 'hooks/useScrollPosition';
import { RiArrowDownLine } from 'react-icons/ri';
import TypeReveal from 'components/TypeReveal';
// import GrainOverlay from 'components/GrainOverlay';
import PropTypes from 'prop-types';

const Container = styled.section`
  position: relative;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.black};
  overflow: hidden;
`;

const Content = styled.div`
  width: 100%;
  height: 100svh;
  ${({ theme }) => theme.mixins.flexColCenter};
  gap: 2rem;
  margin: 0 auto;
  padding: 3rem;
  ${({ theme }) => theme.mediaQueries.sm} {
  }
`;

const Headline = styled.h1`
  visibility: ${({ scrolled }) => (scrolled ? 'hidden' : 'visible')};
  opacity: ${({ scrolled }) => (scrolled ? '0' : '1')};
  cursor: default;
  ${({ theme }) => theme.mixins.HeadlineXLMobile};
  color: ${({ theme }) => theme.colors.white};
  transition:
    visibility 0.6s ease,
    opacity 0.6s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 11rem;

  span {
    text-align-last: justify;
  }

  span:last-of-type {
    color: ${({ theme }) => theme.colors.accent};
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    min-height: 22.4rem;
    gap: 3rem;
    ${({ theme }) => theme.mixins.HeadlineXL};

    span {
      width: max-content;
    }
    span:last-of-type {
      align-self: flex-end;
    }
  }
`;

const NavIcon = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  bottom: 2rem;
  transition: transform 0.3s ease;

  svg {
    font-size: 2rem;
    transition: color 0.3s ease;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      color: ${({ theme }) => theme.colors.accent};
      transform: translateY(0.4rem);
    }
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  z-index: -1;
  height: 100%;
  width: 100vw;
  object-fit: cover;
  pointer-events: none;
`;

const HomeHero = () => {
  const scrolled = useScrollPosition(250);

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Container>
      <Content>
        {/* <GrainOverlay /> */}
        <Headline scrolled={scrolled}>
          <TypeReveal
            text={'Living for'}
            speed={80}
            startDelay={400} // slight delay before typing starts
            retriggerOnScroll={true} // retype every time it scrolls into view
          />
          <TypeReveal
            text={'the story.'}
            speed={80}
            startDelay={1400} // slight delay before typing starts
            retriggerOnScroll={true} // retype every time it scrolls into view
          />
        </Headline>
        <NavIcon onClick={() => handleScroll('intro')}>
          <RiArrowDownLine aria-hidden="true" />
        </NavIcon>
      </Content>
      <BackgroundVideo
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-label="hero background video"
        onEnded={(e) => {
          e.currentTarget.currentTime = 0;
          e.currentTarget.play();
        }}
        poster="https://storage.googleapis.com/tyronshi/home-hero-media/hero-poster-2.webp"
      >
        <source
          src="https://storage.googleapis.com/tyronshi/home-hero-media/hero_1280x720_v1.mp4"
          type="video/mp4"
        />
      </BackgroundVideo>
    </Container>
  );
};

HomeHero.propTypes = {
  headline: PropTypes.string.isRequired,
  socials: PropTypes.array,
};

export default HomeHero;
